module.exports = __webpack_public_path__ + "static/media/logo.7e8fcafd.png";